// extracted by mini-css-extract-plugin
export var blockedMessage = "_77-3";
export var blockedOverlay = "_77-1";
export var fadeIn = "_77-2";
export var hereLink = "_77-0";
export var slideUp = "_77-4";